import { render, staticRenderFns } from "./ubicaciones-empresa.vue?vue&type=template&id=421fe67c&scoped=true"
import script from "./ubicaciones-empresa.vue?vue&type=script&lang=js"
export * from "./ubicaciones-empresa.vue?vue&type=script&lang=js"
import style0 from "./ubicaciones-empresa.vue?vue&type=style&index=0&id=421fe67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421fe67c",
  null
  
)

export default component.exports